<template>
    <v-container grid-list-xl fluid>
        <v-layout>
            <v-flex>
                <h3 class="pr-3">{{ $t('menu.pre_event_poll') }}</h3>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn color="primary" :to="{name: 'event_list'}">{{$t('menu.event_list')}}</v-btn>
        </v-layout>

        <ajax-data-iterator
            ref="pollListIterator"
            :get_url="get_polls_url"
            :url_query="poll_list.params"
            content_tag="v-layout"
            content_class="row wrap"
            :rows_per_page_items="[6]"
        >
            <template slot-scope="props">
                <v-flex xs12 sm6 md4>
                    <v-card>
                        <v-img
                                src="/images/background/poll_bg.jpg"
                                gradient="to top, rgba(0,0,0,.8) 0, rgba(0,0,0,.6) 40%, rgba(0,0,0,0)"
                                aspect-ratio="2.75"
                        >
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-self-end flexbox>
                                        <span class="headline white--text">{{props.item.title}}</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>
<!--                        <v-card-title primary-title>-->
<!--                            <div>-->

<!--                            </div>-->
<!--                        </v-card-title>-->

                        <v-card-actions>
                            <v-btn flat color="primary" @click="viewItem(props.item)">{{$t('action.view')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-menu
                                    transition="scale-transition"
                                    bottom
                                    right
                            >
                                <v-btn
                                        flat
                                        color="primary"
                                        slot="activator"
                                        icon
                                >
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile @click="editItem(props.item)">{{$t('action.edit')}}</v-list-tile>
                                </v-list>
                            </v-menu>

                        </v-card-actions>
                    </v-card>
                </v-flex>
            </template>
        </ajax-data-iterator>

        <v-btn
                color="primary"
                dark
                fab
                fixed
                bottom
                right
                @click="editItem(null, true)"
                class="mb-5"
        >
            <v-icon>add</v-icon>
        </v-btn>

        <save-event-poll-dialog
                ref="save_event_poll_dialog"
                :poll_item="current_poll_item"
                :show_dialog="show_edit_poll_dialog"
                :is_new_item="is_new_item"
                :save_success_callback="save_poll_success_callback"
                v-on:update:show_dialog="show_edit_poll_dialog = $event"
        ></save-event-poll-dialog>

        <v-dialog v-model="view_poll_dialog.show" scrollable max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card v-if="view_poll_dialog.item">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('event.poll.pre_event_poll')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeViewPollDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="v-dialog-body">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <h2 class="mb-2">{{view_poll_dialog.item.title}}</h2>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    :label="$t('event.poll.poll_url')"
                                    class="text-field-without-message mb-2"
                                    v-model="view_poll_dialog.item.poll_url"
                                    outline
                                    readonly
                            >
                                <template slot="append">
                                    <v-menu bottom left>
                                        <v-icon slot="activator">more_vert</v-icon>
                                        <v-list>
                                            <v-list-tile @click="copyUrl(view_poll_dialog.item.poll_url)">
                                                <v-list-tile-title>{{$t('action.copy')}}</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile @click="gotoUrl(view_poll_dialog.item.poll_url)">
                                                <v-list-tile-title>{{$t('action.open')}}</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <div v-if="has_navigation_share">
                                <v-btn color="primary" @click="sharePoll()">{{$t('action.share')}}</v-btn>
                            </div>
                            <div v-else>
                                <div>{{$t('event.poll.msg_share_poll_url')}}:</div>
                                <div>
                                    <v-btn class="ml-0 mr-1" color="green" icon dark @click="shareWithWhatsapp()">
                                        <v-icon>fab fa-whatsapp</v-icon>
                                    </v-btn>
                                    <v-btn class="ml-0 mr-1" color="indigo" icon dark target="_blank" @click="shareWithFacebook()">
                                        <v-icon>fab fa-facebook-f</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </v-flex>

                        <v-flex xs12>
                            <h2 class="mt-3">{{$t('event.poll.poll_result')}}</h2>
                            <p>{{$t('event.poll.poll_result_desc')}}</p>
                        </v-flex>

                        <v-flex xs12 v-if="view_poll_dialog.item.time_question.options.length">
                            <h3>{{$t('event.poll.time_options')}}:</h3>
                            <v-radio-group
                                    row
                                    class="mt-0 option-wrapper"
                                    v-model="view_poll_dialog.time_option"
                            >
                                <template v-for="time_option in view_poll_dialog.item.time_question.options">
                                    <v-layout style="width: 100%">
                                        <v-radio
                                                hide-details
                                                class="shrink mb-2 mt-0 mr-0"
                                                :value="time_option.id"
                                        >
                                            <template slot="label">
                                                <v-layout align-center>

                                                    <div class="stat-info-wrapper mb-2 pb-1">
                                                        <v-progress-linear
                                                                color="primary"
                                                                height="6"
                                                                :value="getOptionVotePercentage(time_option)"
                                                        />
                                                        <v-layout align-end>
                                                            <span>{{getTimeOptionText(time_option.value)}}</span>
                                                            <v-spacer></v-spacer>
                                                            <span class="no-wrap">{{$t('event.poll.vote_desc', {ratio: getOptionVotePercentage(time_option), count: time_option.vote_count})}}</span>
                                                        </v-layout>
                                                    </div>

                                                    <v-spacer></v-spacer>
                                                </v-layout>
                                            </template>
                                        </v-radio>
                                        <v-btn class="my-0" flat icon @click.stop="showVoteDetails(view_poll_dialog.item, time_option)">
                                            <v-icon>visibility</v-icon>
                                        </v-btn>
                                    </v-layout>

                                </template>
                            </v-radio-group>
                        </v-flex>

                        <v-flex xs12 v-if="view_poll_dialog.item.location_question.options.length">
                            <h3>{{$t('event.poll.location_options')}}:</h3>
                            <v-radio-group
                                    row
                                    class="mt-0 option-wrapper"
                                    v-model="view_poll_dialog.location_option"
                            >
                                <template v-for="location_option in view_poll_dialog.item.location_question.options">
                                    <v-layout style="width: 100%">
                                        <v-radio
                                                hide-details
                                                class="shrink mb-2 mt-0 mr-0"
                                                :value="location_option.id"
                                        >
                                            <template slot="label">
                                                <v-layout align-center>
                                                    <div class="stat-info-wrapper mb-2 pb-1">
                                                        <v-progress-linear
                                                                color="primary"
                                                                height="6"
                                                                :value="getOptionVotePercentage(location_option)"
                                                        />
                                                        <v-layout align-end>
                                                            <span>{{location_option.value}}</span>
                                                            <v-spacer></v-spacer>
                                                            <span class="no-wrap">{{$t('event.poll.vote_desc', {ratio: getOptionVotePercentage(location_option), count: location_option.vote_count})}}</span>
                                                        </v-layout>
                                                    </div>
                                                </v-layout>
                                            </template>
                                        </v-radio>
                                        <v-btn class="my-0" flat icon @click.stop="showVoteDetails(view_poll_dialog.item, location_option)">
                                            <v-icon>visibility</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </template>
                            </v-radio-group>
                        </v-flex>

                        <v-flex xs12 v-if="view_poll_dialog.item.activity_question.options.length">
                            <h3>{{$t('event.poll.activity_options')}}:</h3>
                            <template v-for="activity_item in view_poll_dialog.item.activity_question.options">
                                <v-layout style="width: 100%">
                                    <v-checkbox
                                            v-model="view_poll_dialog.activity_option"
                                            class="shrink mb-2 mt-0 option-wrapper"
                                            color="indigo"
                                            :value="activity_item.id"
                                            hide-details
                                    >
                                        <template slot="label">
                                            <v-layout align-center>
                                                <div class="stat-info-wrapper mb-2 pb-1">
                                                    <v-progress-linear
                                                            color="primary"
                                                            height="6"
                                                            :value="getOptionVotePercentage(activity_item)"
                                                    />
                                                    <v-layout align-end>
                                                        <span>{{activity_item.value}}</span>
                                                        <v-spacer />
                                                        <span class="no-wrap">{{$t('event.poll.vote_desc', {ratio: getOptionVotePercentage(activity_item), count: activity_item.vote_count})}}</span>
                                                    </v-layout>
                                                </div>
                                                <v-spacer />
                                            </v-layout>
                                        </template>
                                    </v-checkbox>
                                    <v-btn class="my-0" flat icon @click.stop="showVoteDetails(view_poll_dialog.item, activity_item)">
                                        <v-icon>visibility</v-icon>
                                    </v-btn>
                                </v-layout>
                            </template>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            block
                            @click="createEventWithOptions"
                    >{{$t('event.poll.create_event_with_options')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <save-event-dialog
                ref="save_event_dialog"
                :event_item="save_event_dialog.item"
                :show_dialog="save_event_dialog.show"
                :save_success_callback="save_event_success_callback"
                :is_new_item="true"
                v-on:update:show_dialog="save_event_dialog.show = $event"
        ></save-event-dialog>

        <v-dialog v-model="view_poll_option_dialog.show" scrollable max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>{{view_poll_option_dialog.title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="v-dialog-body">
                    <v-layout v-if="view_poll_option_dialog.loading">
                        <v-flex class="text-xs-center">
                            <v-progress-circular
                                    :size="50"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-flex>
                    </v-layout>
                    <v-list v-else>
                        <template v-if="view_poll_option_dialog.items.length">
                            <v-list-tile
                                    v-for="(item, index) in view_poll_option_dialog.items"
                                    :key="index"
                                    avatar
                            >
                                <v-list-tile-avatar>
                                    <v-icon>person</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{item.contact_name}}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                        <template v-else>
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{$t('general.no_record_found')}}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-card-text>
                <v-spacer></v-spacer>
                <v-card-actions class="shrink">
                    <v-spacer />
                    <v-btn color="blue darken-1" flat @click="view_poll_option_dialog.show = false">{{$t('action.close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    import AjaxDataIterator from '~/components/widgets/data/AjaxDataIterator'
    import SaveEventPollDialog from "~/components/event/poll/SaveEventPollDialog";
    import {UrlServices} from "~/utils/url-manager";
    import Utils from "~/utils";
    import SaveEventDialog from "~/components/event/SaveEventDialog";
    import RequestHandler from "~/utils/request-handler";
    import {CancelToken} from "axios";

    export default {
        components: {
            SaveEventDialog,
            SaveEventPollDialog,
            AjaxDataIterator
        },
        data() {
            return {
                poll_list: {
                    searching: false,
                    params: {

                    }
                },
                show_edit_poll_dialog: false,
                current_poll_item: {},
                is_new_item: false,
                save_poll_success_callback: function() {},
                save_event_success_callback: function() {},
                view_poll_dialog: {
                    show: false,
                    item: null,
                    time_option: null,
                    location_option: null,
                    activity_option: [],
                },
                view_poll_option_dialog: {
                    show: false,
                    title: "",
                    items: [],
                    loading: true,
                    cancel_request: () => {}
                },
                save_event_dialog: {
                    show: false,
                    item: {
                        title: "",
                        location_text: ""
                    }
                }
            };
        },
        computed: {
            get_polls_url() {
                return UrlServices.createUrl({name: 'api_event_poll_list'});
            },
            has_navigation_share() {
                return !!navigator.share;
            },
        },
        methods: {
            editItem(item = null, is_new_item = false) {
                if(item){
                    item = _.extend({}, item);
                }
                this.is_new_item = is_new_item;
                this.current_poll_item = item;
                this.show_edit_poll_dialog = true;
            },
            viewItem(item) {
                let me = this;
                this.view_poll_dialog.item = item;

                me.view_poll_dialog.time_option = null;
                me.view_poll_dialog.location_option = null;
                me.view_poll_dialog.activity_option = [];

                if(item.time_question.options.length){
                    _.each(item.time_question.options, function(option){
                        if(option.is_max_vote){
                            me.view_poll_dialog.time_option = option.id;
                        }
                    });
                }

                if(item.location_question.options.length){
                    _.each(item.location_question.options, function(option){
                        if(option.is_max_vote){
                            me.view_poll_dialog.location_option = option.id;
                        }
                    });
                }

                if(item.activity_question.options.length){
                    _.each(item.activity_question.options, function(option){
                        me.view_poll_dialog.activity_option.push(option.id);
                    });
                }


                this.view_poll_dialog.show = true;
            },
            closeViewPollDialog() {
                this.view_poll_dialog.item = null;
                this.view_poll_dialog.show = false;
            },
            copyUrl(url) {
                let me = this;
                this.$copyText(url).then(function () {
                    getApp.snackbar = {
                        show: true,
                        color: 'green',
                        text: me.$t('app.msg_copy_success'),
                        timeout: 3000
                    };
                }, function (e) {
                    console.log('Can not copy');
                    console.log(e);
                })
            },
            gotoUrl(url) {
                window.open(url, '_blank');
            },
            getTimeOptionText(value) {
                return Utils.getPeriodText(value['start_time'], value['end_time']);
            },
            getOptionVotePercentage(option) {
                if(option.question_vote_count){
                    return Math.round((option.vote_count/option.question_vote_count) * 10000) / 100;
                } else {
                    return 0;
                }
            },
            createEventWithOptions() {
                let poll_item = this.view_poll_dialog.item;

                let event_title = poll_item.title;
                let selected_time_option = this.view_poll_dialog.time_option;
                let selected_location_option = this.view_poll_dialog.location_option;
                let selected_activity_option = this.view_poll_dialog.activity_option;

                let location = "";
                let activity = [];
                let start_timestamp = getApp.$moment().format('X');
                let end_timestamp = getApp.$moment().add(7200, 'seconds').format('X');

                if(selected_time_option){
                    _.each(poll_item.time_question.options, function(option){
                        if(option.id == selected_time_option){
                            start_timestamp = option.value.start_time;
                            end_timestamp = option.value.end_time;
                        }
                    });
                }

                if(selected_location_option){
                    _.each(poll_item.location_question.options, function(option) {
                        if(option.id == selected_location_option){
                            location = option.value;
                        }
                    })
                }

                if(selected_activity_option.length){
                    _.each(poll_item.activity_question.options, function(option) {
                        if(_.includes(selected_activity_option, option.id)){
                            activity.push({
                                id: Utils.getUniqueId(),
                                name: option.value,
                                quota: ""
                            });
                        }
                    });
                }

                let item = {
                    id: 0,
                    title: event_title,
                    location_text: location,
                    start_timestamp: start_timestamp,
                    end_timestamp: end_timestamp,
                    enrollment_start_timestamp: null,
                    enrollment_end_timestamp: null,
                    enable_enrollment_time: false,
                    enable_for_enrollment: 1,
                    display_media: 1,
                    display_registrants: 1,
                    cover_file: null,
                    event_photos: [],
                    event_attachments: [],
                    is_private: 0,
                    ask_for_attend: 1,
                    allow_invited_contact_only: 1,
                    allow_guest_to_join: 1,
                    enable_select_name_from_invitations: 1,
                    activities: activity,
                    removed_activity: []
                };

                this.save_event_dialog.item = item;
                this.save_event_dialog.show = true;

                this.closeViewPollDialog();
            },
            sharePoll() {
                let message = this.$t('event.poll.msg_share_event_text', {
                    'event_name': this.view_poll_dialog.item.title,
                });
                this.shareUrl(this.view_poll_dialog.item.poll_url, message);
            },
            shareUrl(url, text) {
                navigator.share({
                    url: url,
                    text: text
                })
            },
            shareWithWhatsapp() {
                let message = this.$t('event.poll.msg_share_event', {
                    'event_name': this.view_poll_dialog.item.title,
                    'url': this.view_poll_dialog.item.poll_url,
                });
                this.whatsappShareFunction(message);
            },
            shareWithFacebook() {
                window.open("https://www.facebook.com/sharer/sharer.php?u=" + this.view_poll_dialog.item.poll_url, null, 'width=640,height=400');
            },
            whatsappShareFunction(message) {
                window.open("https://api.whatsapp.com/send?text=" + encodeURIComponent(message))
            },
            showVoteDetails(poll_item, option) {
                let me = this;
                this.view_poll_option_dialog.title = this.$t('general.loading');
                this.view_poll_option_dialog.show = true;
                this.view_poll_option_dialog.loading = true;

                let config = {
                    cancelToken: new CancelToken(function executor(c) {
                        me.view_poll_option_dialog.cancel_request = c;
                    })
                };

                let params = {
                    'poll_id': poll_item.id,
                    'option_id': option.id
                };

                RequestHandler.Get(UrlServices.createUrl({'name': 'api_event_poll_get_option_details'}), params, {
                    'success': function(data) {
                        me.view_poll_option_dialog.title = me.$t('event.poll.voter_list', {'count': data.length})

                        me.view_poll_option_dialog.items = data;
                        me.view_poll_option_dialog.loading = false;
                    }
                }, config);
            }
        },
        mounted() {
            let me = this;

            this.save_poll_success_callback = function(data) {
                me.$refs.pollListIterator.getDataFromApi();

                let message = "";

                if(data['is_new_record']){
                    message = me.$t('app.msg_create_success');
                } else {
                    message = me.$t('app.msg_edit_success');
                }

                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };
            };

            this.save_event_success_callback = function(data){

                let message = "";

                if(data['is_new_record']){
                    message = me.$t('app.msg_create_success');
                } else {
                    message = me.$t('app.msg_edit_success');
                }

                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };
            };
        }
    }
</script>

<style>
    h3 {
        font-size: 24px;
    }
    .stat-info-wrapper {
        position: relative;
        width: 100%;
    }
    .full-width {
        width: 100%;
    }
    .option-wrapper, .option-wrapper .v-radio, .option-wrapper .v-label, .option-wrapper .v-input__control {
        width: 100%;
    }
    .flexcard {
        display: flex;
        flex-direction: column;
    }
</style>